import React, { Component } from "react";
import LoginContainer from "./LoginContainer/LoginContainer";
import RegisterContainer from "./RegisterContainer/RegisterContainer";
import ForgotPasswordContainer from "./ForgotPasswordContainer/ForgotPasswordContainer";
import Aux from "../../hoc/Auxilliary";
import ResetPassword from "./ResetPassword/ResetPassword";

class Login extends Component {
  componentDidMount() {}
  componentDidUpdate() {
    // console.log("Login js updated");
  }
  render() {
    const page = this.props.page;
    let layoutContainer = null;
    if (page === "login") {
      layoutContainer = <LoginContainer key="login1" {...this.props} />;
    } else if (page === "register") {
      layoutContainer = <RegisterContainer />;
    } else if (page === "forgotpassword") {
      layoutContainer = <ForgotPasswordContainer />;
    } else if (page === "resetpassword") {
      layoutContainer = <ResetPassword {...this.props} />;
    } else {
      layoutContainer = <LoginContainer key="login2" {...this.props} />;
    }

    return (
      <Aux key="aux1">
        <div className="login_bg">
          <div className="container">
            <div className="row">
              <div className="login_text">
                <h3>Welcome to the</h3>
                <h2>
                  <span>ASML</span> - Learning program
                </h2>
              </div>
            </div>
          </div>

          <div className="container">{layoutContainer}</div>
        </div>
        <div id="bg">{/* <img src="/images/login_bg.jpg" alt="" /> */}</div>
      </Aux>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js